import styled, { css } from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const CircleContainer = styled.div<{ totalItems: number }>`
    position: relative;
    /*This fixes the slider width calculation bug. (items x 14 (width+margin) + 2 times the items with margin only */
    width: ${(props) => props.totalItems * 14 + props.totalItems * 2 * theme.space[1]}px;
    height: 10px;
    overflow: hidden;
`;

export const CircleTrack = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    transition: left 0.3s;

    html[dir="rtl"] & {
        left: auto;
        right: 0;
    }
`;
export const Circle = styled.div<{ active: boolean; size: number; invertedColour: boolean }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    margin: 0 ${theme.space[1] / 2}px;
    background: ${theme.colors.grey3};
    border-radius: 4px;
    transition:
        opacity 0.3s,
        width 0.3s,
        height 0.3s,
        margin 0.3s;
    opacity: ${(props) => (props.invertedColour ? 1 : 0.5)};
    ${({ active }) =>
        active &&
        css`
            background: ${theme.colors.grey7};
            opacity: 1;
        `};

    &:hover {
        opacity: 1;
    }
`;
